<template>
	<div class="seoMarkup">
		<div
			class="seoMarkup__content"
			v-for="seo in filterSeoContent"
			:key="seo.id"
		>
			<h1 v-if="showHeader">{{ seo.title }}</h1>
			<div v-html="seo.content"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SportSeoContentBlock",
	data() {
		return {
			filteredSeoContent: null,
			sportsRoute: false,
			showHeader: false,
		};
	},
	computed: {
		loadSeoContentBlock() {
			return this.$store.getters.getSeoContentBlock;
		},
		pageRoute() {
			return this.$route.params.hasOwnProperty("sportName")
				? this.$route.params.sportName
				: this.$route.name;
		},
		filterSeoContent() {
			const routeToSportCategoryMap = {
				"/aviator": "aviator",
				"/casino/game": "casino",
				"/betika-fasta": "betika-fasta",
				"/crash-game": "crash-games",
			};

			const isHomeRoute = this.$route.name === "home";
			const currentPath = this.$route.path;
			let currentSportCategory = routeToSportCategoryMap[currentPath];

			// Check if current path includes any of the specific routes for Betika Fasta or Crash Games
			const isBetikaFastaOrCrashGamesRoute = [
				"/betika-fasta",
				"/crash-game",
			].some((route) => currentPath.includes(route));

			if (isBetikaFastaOrCrashGamesRoute) {
				currentSportCategory = Object.keys(routeToSportCategoryMap).find(
					(route) => currentPath.includes(route)
				);
				currentSportCategory =
					routeToSportCategoryMap[currentSportCategory] || currentSportCategory;
			}

			if (
				isHomeRoute &&
				!routeToSportCategoryMap.hasOwnProperty(this.$route.path)
			) {
				this.showHeader = true;
			} else {
				this.showHeader = false;
			}

			return this.loadSeoContentBlock.filter((item) => {
				if (!item.sportCategory) return null;

				if (
					item.sportCategory.toLowerCase() === this.pageRoute &&
					this.$route.name === "sport"
				) {
					return item;
				} else if (this.pageRoute === "home" && this.$route.name === "home") {
					return item.id === 1;
				} else if (
					currentSportCategory &&
					item.sportCategory.toLowerCase() === currentSportCategory
				) {
					return item;
				} else {
					return null;
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.seoMarkup {
	padding: 5px 10px;
	color: var(--light-black);
	font-weight: var(--font-weight-lighter);
	margin-top: -40px;
	padding-top: 15px;
	border-top: 1px solid var(--line-11-1);

	&__content {
		h1 {
			font-size: 11px;
			margin-bottom: 12px;
			line-height: 21px;
		}

		::v-deep h2,
		::v-deep h3,
		::v-deep p,
		::v-deep li {
			font-size: 11px;
			margin-bottom: 12px;
			line-height: 21px;
		}

		::v-deep a:not([class]) {
			font-weight: 700;
			color: var(--green);
			text-decoration: none;
		}
	}
}
</style>
